"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeleteIcon = DeleteIcon;
var React = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function DeleteIcon() {
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/forbid-elements
    React.createElement("svg", {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("g", {
      clipPath: "url(#clip0_7168_65355)"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M20 9V21C20 21.5304 19.7893 22.0391 19.4142 22.4142C19.0391 22.7893 18.5304 23 18 23H6C5.46957 23 4.96086 22.7893 4.58579 22.4142C4.21071 22.0391 4 21.5304 4 21V9",
      stroke: "#DB1F36",
      strokeWidth: "2",
      strokeMiterlimit: "10",
      strokeLinecap: "square"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M1 5H23",
      stroke: "#DB1F36",
      strokeWidth: "2",
      strokeMiterlimit: "10",
      strokeLinecap: "square"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12 12V18",
      stroke: "#DB1F36",
      strokeWidth: "2",
      strokeMiterlimit: "10",
      strokeLinecap: "square"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 12V18",
      stroke: "#DB1F36",
      strokeWidth: "2",
      strokeMiterlimit: "10",
      strokeLinecap: "square"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16 12V18",
      stroke: "#DB1F36",
      strokeWidth: "2",
      strokeMiterlimit: "10",
      strokeLinecap: "square"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8 5V1H16V5",
      stroke: "#DB1F36",
      strokeWidth: "2",
      strokeMiterlimit: "10"
    })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
      id: "clip0_7168_65355"
    }, /*#__PURE__*/React.createElement("rect", {
      width: "24",
      height: "24",
      fill: "white"
    }))))
  );
}